import { useState } from "react";

import type { ConfirmDialogProps } from "@/ds";

export const DESCARTE_HEADER = "Tem certeza?";
export const DESCARTE_MESSAGE = "As informações preenchidas serão perdidas.";
export const DESCARTE_ACCEPT_LABEL = "Descartar";
export const DESCARTE_REJECT_LABEL = "Continuar editando";

interface UseConfirmarDescarteParams {
  onDescartar: () => void;
  testId: string;
}

export function useConfirmarDescarte({ onDescartar, testId }: UseConfirmarDescarteParams) {
  const [aberto, setAberto] = useState(false);

  const continuar = () => setAberto(false);

  const confirmacao: ConfirmDialogProps | null = aberto
    ? {
        visible: true,
        variant: "destructive",
        header: DESCARTE_HEADER,
        message: DESCARTE_MESSAGE,
        acceptLabel: DESCARTE_ACCEPT_LABEL,
        rejectLabel: DESCARTE_REJECT_LABEL,
        accept: () => {
          setAberto(false);
          onDescartar();
        },
        reject: continuar,
        onHide: continuar,
        testId,
      }
    : null;

  return {
    pedir: (temDado: boolean) => {
      if (temDado) setAberto(true);
      else onDescartar();
    },
    confirmacao,
  };
}
